"use client";
import { usePrivy } from "@privy-io/react-auth";
import { useMemo } from "react";
import { useEvmWallet } from "./useEvmWallet";
import { useGetIdentities } from "./useGetIdentities";
import { useRewardsLeaderboard } from "./useRewardsLeaderboard";

/**
 * Returns the current user's rewards points from the shared leaderboard cache.
 * Uses the same `useRewardsLeaderboard` query so there is no extra network call.
 */
export const useGetUserPoints = () => {
	const { authenticated } = usePrivy();
	const { address } = useEvmWallet();

	// Get user's identity
	const { data: identitiesPage } = useGetIdentities({ owner: address });
	const primaryIdentity = identitiesPage?.pages.flatMap(
		(page) => page ?? [],
	)[0];

	const { data: leaderboard = [], ...rest } = useRewardsLeaderboard();

	const points = useMemo(() => {
		if (!authenticated || !primaryIdentity?.identityRaw) return 0;
		const match = leaderboard.find(
			(entry) => entry.identity === primaryIdentity.identityRaw,
		);
		return match?.points ?? 0;
	}, [leaderboard, primaryIdentity?.identityRaw, authenticated]);

	return { data: points, ...rest };
};
